import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useNavigate } from "react-router-dom";
import { useGetProfileMutation } from "../../services/apis/auth";
import { useSelector, useDispatch } from "react-redux";
import { useLogout } from "../../services/utilities/logoutUtility";
import { DialogContent, DialogTitle ,DialogContentText, Dialog, DialogActions, Button} from "@mui/material";

const DrawerInfo = [
  {
    icon: "/icons/Dashboard.png",
    name: "Dashboard",
    path: "/main/dashboard",
  },

  {
    icon: "/icons/Exams.png",
    name: "Exams",
    path: "/main/exam",
  },
  {
    icon: "/icons/InterestGroups.png",
    name: "Interest Groups",
    path: "/main/interest/groups",
  },
  {
    icon: "/icons/Sales.png",
    name: "Sales",
    path: "/main/sales",
  },
  {
    icon: "/icons/Rewards.png",
    name: "Reward",
    path: "/main/rewards",
  },
  //   {
  //   icon: "/icons/StudyRoom.png",
  //   name: "Study Room",
  //   path: "/main/ticket",
  // },

  // {
  //   icon: "/icons/Student.png",
  //   name: "Students Management",
  //   path: "/main/student",
  // },

  {
    icon: "/icons/Student.png",
    name: "Authority Management",
    path: "/main/management/user",
  },

  {
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0NTU1NjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXRpY2tldCI+PHBhdGggZD0iTTIgOWEzIDMgMCAwIDEgMCA2djJhMiAyIDAgMCAwIDIgMmgxNmEyIDIgMCAwIDAgMi0ydi0yYTMgMyAwIDAgMSAwLTZWN2EyIDIgMCAwIDAtMi0ySDRhMiAyIDAgMCAwLTIgMloiLz48cGF0aCBkPSJNMTMgNXYyIi8+PHBhdGggZD0iTTEzIDE3djIiLz48cGF0aCBkPSJNMTMgMTF2MiIvPjwvc3ZnPg==",
    name: "Doubt Management",
    path: "/main/doubt-management",
  },
  {
    icon: "/icons/FAQ.png",
    name: "Data Management",
    path: "/main/data",
  },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jYWxlbmRhci1jbG9jayI+PHBhdGggZD0iTTIxIDcuNVY2YTIgMiAwIDAgMC0yLTJINWEyIDIgMCAwIDAtMiAydjE0YTIgMiAwIDAgMCAyIDJoMy41Ii8+PHBhdGggZD0iTTE2IDJ2NCIvPjxwYXRoIGQ9Ik04IDJ2NCIvPjxwYXRoIGQ9Ik0zIDEwaDUiLz48cGF0aCBkPSJNMTcuNSAxNy41IDE2IDE2LjNWMTQiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSI2Ii8+PC9zdmc+",
  //   name: "Event Management",
  //   // path: "/main/events",
  //   path: "/main/event",
  // },
  {
    icon: "/icons/questions.png",
    name: "Content Management",
    path: "/main/content-management",
  },
  // {
  //   icon: "/icons/announcement.png",
  //   name: "Announcement",
  //   path: "/main/announcement",
  // },
  {
    icon: "/icons/announcement.png",
    name: "Marketing",
    path: "/main/marketing",
  },
  //   {
  //   icon: "/icons/session.png",
  //   name: "Session Class",
  //   path: "/main/session-class",
  // },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jYWxlbmRhci1jbG9jayI+PHBhdGggZD0iTTIxIDcuNVY2YTIgMiAwIDAgMC0yLTJINWEyIDIgMCAwIDAtMiAydjE0YTIgMiAwIDAgMCAyIDJoMy41Ii8+PHBhdGggZD0iTTE2IDJ2NCIvPjxwYXRoIGQ9Ik04IDJ2NCIvPjxwYXRoIGQ9Ik0zIDEwaDUiLz48cGF0aCBkPSJNMTcuNSAxNy41IDE2IDE2LjNWMTQiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSI2Ii8+PC9zdmc+",
  //   name: "Session",
  //   path: "/main/session",
  // },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jYWxlbmRhci1jbG9jayI+PHBhdGggZD0iTTIxIDcuNVY2YTIgMiAwIDAgMC0yLTJINWEyIDIgMCAwIDAtMiAydjE0YTIgMiAwIDAgMCAyIDJoMy41Ii8+PHBhdGggZD0iTTE2IDJ2NCIvPjxwYXRoIGQ9Ik04IDJ2NCIvPjxwYXRoIGQ9Ik0zIDEwaDUiLz48cGF0aCBkPSJNMTcuNSAxNy41IDE2IDE2LjNWMTQiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSI2Ii8+PC9zdmc+",
  //   name: "Mock",
  //   path: "/main/mock",
  // },


  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jYWxlbmRhci1jbG9jayI+PHBhdGggZD0iTTIxIDcuNVY2YTIgMiAwIDAgMC0yLTJINWEyIDIgMCAwIDAtMiAydjE0YTIgMiAwIDAgMCAyIDJoMy41Ii8+PHBhdGggZD0iTTE2IDJ2NCIvPjxwYXRoIGQ9Ik04IDJ2NCIvPjxwYXRoIGQ9Ik0zIDEwaDUiLz48cGF0aCBkPSJNMTcuNSAxNy41IDE2IDE2LjNWMTQiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSI2Ii8+PC9zdmc+",
  //   name: "Roles Management",
  //   path: "/main/roles",
  // },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0NTQ1NDUiIHN0cm9rZS13aWR0aD0iMS43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1mbGFtZSI+PHBhdGggZD0iTTguNSAxNC41QTIuNSAyLjUgMCAwIDAgMTEgMTJjMC0xLjM4LS41LTItMS0zLTEuMDcyLTIuMTQzLS4yMjQtNC4wNTQgMi02IC41IDIuNSAyIDQuOSA0IDYuNSAyIDEuNiAzIDMuNSAzIDUuNWE3IDcgMCAxIDEtMTQgMGMwLTEuMTUzLjQzMy0yLjI5NCAxLTNhMi41IDIuNSAwIDAgMCAyLjUgMi41eiIvPjwvc3ZnPg==",
  //   name: "Daily Streak",
  //   path: "/main/dailyStreak",
  // },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0ZjRmNGYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1maWxlLXZpZGVvIj48cGF0aCBkPSJNMTUgMkg2YTIgMiAwIDAgMC0yIDJ2MTZhMiAyIDAgMCAwIDIgMmgxMmEyIDIgMCAwIDAgMi0yVjdaIi8+PHBhdGggZD0iTTE0IDJ2NGEyIDIgMCAwIDAgMiAyaDQiLz48cGF0aCBkPSJtMTAgMTEgNSAzLTUgM3YtNloiLz48L3N2Zz4=",
  //   name: "Video Bank",
  //   path: "/main/video/bank",
  // },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDEyIDEyIj4gPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMiIgcnk9IjIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIi8+PGxpbmUgeDE9IjYiIHkxPSI2IiB4Mj0iMTQiIHkyPSI2IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPjxsaW5lIHgxPSI2IiB5MT0iMTAiIHgyPSIxNCIgeTI9IjEwIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPjxsaW5lIHgxPSI2IiB5MT0iMTQiIHgyPSIxNCIgeTI9IjE0IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==",
  //   name: "Note Bank",
  //   path: "/main/note/bank",
  // },
  {
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDEyIDEyIj4gPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMiIgcnk9IjIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIi8+PGxpbmUgeDE9IjYiIHkxPSI2IiB4Mj0iMTQiIHkyPSI2IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPjxsaW5lIHgxPSI2IiB5MT0iMTAiIHgyPSIxNCIgeTI9IjEwIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPjxsaW5lIHgxPSI2IiB5MT0iMTQiIHgyPSIxNCIgeTI9IjE0IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==",
    name: "Bank",
    path: "/main/bank",
  },
  {
    icon: "/icons/Blog.png",
    name: "Blog",
    path: "/main/blogs",
  },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0ZjRmNGYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1maWxlLXZpZGVvIj48cGF0aCBkPSJNMTUgMkg2YTIgMiAwIDAgMC0yIDJ2MTZhMiAyIDAgMCAwIDIgMmgxMmEyIDIgMCAwIDAgMi0yVjdaIi8+PHBhdGggZD0iTTE0IDJ2NGEyIDIgMCAwIDAgMiAyaDQiLz48cGF0aCBkPSJtMTAgMTEgNSAzLTUgM3YtNloiLz48L3N2Zz4=",
  //   name: "Upload Image",
  //   path: "/main/upload/image",
  // },

  // {
  //   icon: "/icons/UserManagement.png",
  //   name: "User Management",
  //   path: "/main/user",
  // },
  // {
  //   icon: "/icons/FAQ.png",
  //   name: "FAQ",
  //   path: "/main/faq",
  // },
  {
    icon: "/icons/feed.png",
    name: "Feed Algo",
    path: "/main/feed",
  },
  {
    icon: "/icons/copy.png",
    name: "Logs",
    path: "/main/logs",
  },
];

const adminDrawerInfo = [
  // {
  //   icon: "/icons/UserManagement.png",
  //   name: "User Management",
  //   path: "/main/user",

  // },
  // {
  //   icon: "/icons/Student.png",
  //   name: "Roles Management",
  //   path: "/main/roles",
  // },
  // {
  //   icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM0NTQ1NDUiIHN0cm9rZS13aWR0aD0iMS43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1mbGFtZSI+PHBhdGggZD0iTTguNSAxNC41QTIuNSAyLjUgMCAwIDAgMTEgMTJjMC0xLjM4LS41LTItMS0zLTEuMDcyLTIuMTQzLS4yMjQtNC4wNTQgMi02IC41IDIuNSAyIDQuOSA0IDYuNSAyIDEuNiAzIDMuNSAzIDUuNWE3IDcgMCAxIDEtMTQgMGMwLTEuMTUzLjQzMy0yLjI5NCAxLTNhMi41IDIuNSAwIDAgMCAyLjUgMi41eiIvPjwvc3ZnPg==",
  //   name: "Daily Streak",
  //   path: "/main/dailyStreak",
  // },
]

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  zIndex: theme.zIndex.drawer,
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer({ open, setOpen }) {
  const user = useSelector((state) => state.users.userInfo);
  const [profileData, setProfileData] = React.useState(null);
  const [openLogoutDialog, setOpenLogoutDialog] = React.useState(false);
  const roles = user?.roles
  const dispatch = useDispatch();

  // console.log(user,'user......')


  const [getProfile] = useGetProfileMutation();
  const { logout } = useLogout();
  const theme = useTheme();
  // const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const handleDrawer = () => {
    setOpen(!open);
  };
  const handleClick = (path) => {
    navigate(path);
    if (open) {
      setOpen(false);
    }
  };

  const handleLogout = async () => {
    await logout({
      uid: user?._id,
      dispatch,
      navigate,
      callApi: true,
      clearStorage: true,
      navigateToSignin: true
    });
    localStorage.clear();
  };


   const handleLogoutClick = () => {
      setOpenLogoutDialog(false)
      setOpenLogoutDialog(true); // Open the confirmation dialog
    };
  
    // const handleConfirmLogout = async () => {
    //   setOpenLogoutDialog(false);
    //   try {
    //     const response = await logout({ uid: user._id }).unwrap();
  
    //     if (response.success) {
    //       localStorage.removeItem("token");
    //       localStorage.removeItem("user");
    //       localStorage.clear();
    //       navigate("/auth/signin");
    //       toast(response.message)
    //     } else {
    //       // console.error("Logout failed:", response.message);
    //       toast(response.message)
    //     }
    //   } catch (error) {
    //     // console.error("Error during logout:", error);
    //     toast(error.data.message)
    //   }
    // };
  const fetchProfile = async () => {
    try {
      const response = await getProfile({ uid: user._id }).unwrap();
      if (response.success) {
        setProfileData(response.data);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  }


  React.useEffect(() => {
    if (user && user._id) {
      fetchProfile();
    }
  }, [user]);

  React.useEffect(() => {
    if (!user?._id) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/auth/signin");
    }
  }, [])

  // const isAdmin = profileData?.user?.roles?.includes("admin") || profileData?.user?.roles?.includes("superAdmin");
  // const allDrawerItems = [
  //   ...DrawerInfo,
  //   ...(isAdmin ? adminDrawerInfo : [])
  // ];

  // const mainItems = allDrawerItems.slice(0, allDrawerItems.length - 3);
  // const bottomItems = allDrawerItems.slice(allDrawerItems.length - 3);


  // Role checks
  const isAdmin = profileData?.user?.roles?.includes("admin") || profileData?.user?.roles?.includes("superAdmin");

  // const isDoubtSolver = profileData?.user?.roles?.includes("doubtSolver");
  const isDoubtSolver = !isAdmin && profileData?.user?.roles?.includes("doubtSolver");
  const isTeacherOrModerator = !isAdmin && (profileData?.user?.roles?.includes("teacher") || profileData?.user?.roles?.includes("moderator"));
  const isContentDeveloper = !isAdmin && profileData?.user?.roles?.includes("contentDeveloper");

  // Decide drawer items based on role
  let allDrawerItems = [];
  if (isAdmin) {
    allDrawerItems = [...DrawerInfo, ...adminDrawerInfo];
  }
  else if (isDoubtSolver) {
    allDrawerItems = DrawerInfo.filter((item) => item.name === "Doubt Management");
  }
  else if (isContentDeveloper) {
    allDrawerItems = DrawerInfo.filter((item) => item.name === "Content Developer");
  }
  else if (isTeacherOrModerator) {
    allDrawerItems = DrawerInfo.filter((item) =>
      ["Event Management", "Exams", "Session Class", "Doubt Management"].includes(item.name)
    );
  }
  else {
    allDrawerItems = [...DrawerInfo];
  }

  // const mainItems = allDrawerItems.slice(0, allDrawerItems.length - 3);
  // const bottomItems = allDrawerItems.slice(allDrawerItems.length - 3);

  const mainItems = allDrawerItems
  // const bottomItems = allDrawerItems.slice(allDrawerItems.length - 3);


  return (
    <Box>
      <CssBaseline />

      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ justifyContent: open && "space-between", pt: 1 }}>
          <Box
            component="img"
            sx={{ opacity: open ? 1 : 0, ml: 2 }}
            // src="/backgroundImages/iQuanta.png"
            src="/logo.jpg"
            height={40}
          />
          <IconButton onClick={handleDrawer}>
            {open ? (
              <CloseRoundedIcon className="text-primary" />
            ) : (
              <MenuRoundedIcon className="text-primary" />
            )}
          </IconButton>
        </DrawerHeader>

        {/* <List  >
          {mainItems.map((data, index) => (
            <ListItem key={index} disablePadding sx={{ display: "block" }} >
              <ListItemButton

                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  mt: 1,
                  "&:hover": {
                    transform: "scale(1.05)",
                    transition: "all   0.3s ease-in-out", // Add ease-in-out transition
                  },
                }}
                onClick={() => handleClick(data.path)}
              >
                <ListItemIcon

                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",


                  }}
                >
                  <img src={data.icon} alt={data.name} />
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                  <Typography variant="text">{data.name}</Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
        </List> */}
        <List>
          {mainItems.map((data, index) => {
            // const isDisabled = isDoubtSolver && data.name !== "Doubt Management"; // fade others for doubtSolver
            const isDisabled =
              (isDoubtSolver && data.name !== "Doubt Management") ||
              (isTeacherOrModerator && !["Event Management", "Exams", "Session Class", "Doubt Management"].includes(data.name));

            return (
              <ListItem key={index} disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                    mt: 1,
                    opacity: isDisabled ? 0.4 : 1, // 👈 fade if disabled
                    pointerEvents: isDisabled ? "none" : "auto", // prevent clicks if disabled
                    "&:hover": {
                      transform: isDisabled ? "none" : "scale(1.05)",
                      transition: "all 0.3s ease-in-out",
                    },
                  }}
                  onClick={() => !isDisabled && handleClick(data.path)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img src={data.icon} alt={data.name} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <Typography variant="text">{data.name}</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
          <ListItem disablePadding sx={{ display: "block", mt: 2 }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
                "&:hover": {
                  transform: "scale(1.05)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
              onClick={handleLogoutClick}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <img src="/icons/logout.png" alt="Logout" />
              </ListItemIcon>
              <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                <Typography variant="text">Logout</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>

        <Dialog open={openLogoutDialog} onClose={() => setOpenLogoutDialog(false)}>
          <DialogTitle>Confirm Logout</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to logout?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenLogoutDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={handleLogout} color="error">
              Logout
            </Button>
          </DialogActions>
        </Dialog>

        {/* <Divider /> */}

        {/* <List style={{ marginTop: "auto" }}  >
          {bottomItems.map((data, index) => (
            <ListItem key={index} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  mt: 1,
                  "&:hover": {
                    transform: "scale(1.1)",
                    transition: "all   0.2s ease-in-out", // Add ease-in-out transition
                  },
                }}
                onClick={() => handleClick(data.path)}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img src={data.icon}></img>{" "}
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                  <Typography variant="text">{data.name}</Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
        </List> */}

        {/* <List style={{ marginTop: "auto" }}>
          {bottomItems.map((data, index) => {
            const isDisabled = (isDoubtSolver && data.name !== "Doubt Management") ||
              (isTeacherOrModerator &&!["Event Management", "Exams", "Session Class", "Doubt Management"].includes(data.name));

            return (
              <ListItem key={index} disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                    mt: 1,
                    opacity: isDisabled ? 0.4 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                    "&:hover": {
                      transform: isDisabled ? "none" : "scale(1.1)",
                      transition: "all 0.2s ease-in-out",
                    },
                  }}
                  onClick={() => !isDisabled && handleClick(data.path)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img src={data.icon} alt={data.name} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <Typography variant="text">{data.name}</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List> */}

      </Drawer>
    </Box>
  );
}
